import React, { useEffect, useState } from 'react'
import icons from '../../assets/images/sprite-other-icons.svg'
import {
  handleChangePin,
  handleLogout,
  setValidationError
} from './cl_ChangePinSlice'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getFromLocalStorage, removeFromLocalStorage } from '../../services/helper/cl_Helper'

function ChangePin () {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { changePinStatus, validationError, isLoading } = useSelector(
    state => state.changepin
  )
  const [pin, setPin] = useState({
    oldPin: '',
    newPin: '',
    confirmPin: ''
  })
  const [pinType, setPinType] = useState({
    oldPinType: 'password',
    newPinType: 'password',
    confirmPinType: 'password'
  })
  const [oldPinError, setOldPinError] = useState('')
  const [newPinError, setNewPinError] = useState('')
  const [confirmPinError, setConfirmPinError] = useState('')
  const [accessToken, setAccessToken] = useState(getFromLocalStorage('gk'))
  const [pinChangedMsg, setPinChangedMsg] = useState('')

  const handlePinVisibility = pinName => {
    setPinType(prevPinType => {
      return {
        ...prevPinType,
        [pinName]: prevPinType[pinName] === 'text' ? 'password' : 'text'
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (isLoading) return; // Prevent multiple submissions while loading
    
    if (
      pin.oldPin.trim() === '' && pin.oldPin.length < 4 &&
      pin.newPin.trim() === '' && pin.newPin.length < 4 && 
      pin.confirmPin.trim() === '' && pin.confirmPin.length < 4 
    ) {
      setOldPinError('Please enter a Valid 4 Digit PIN')
      setNewPinError('Please enter a Valid 4 Digit PIN')
      setConfirmPinError('Please confirm your 4-digit PIN')
    } else if (pin.oldPin.trim() === '') {
      setOldPinError('Please enter a Valid 4 Digit PIN')
    } else if (pin.oldPin.length < 4) {
      setOldPinError('Please enter a Valid 4 Digit PIN')
    } else if (pin.newPin.trim() === '') {
      setNewPinError('Please enter a Valid 4 Digit PIN')
    } else if (pin.newPin.length < 4) {
      setNewPinError('Please enter a Valid 4 Digit PIN')
    } else if (pin.confirmPin.trim() === '' || pin.confirmPin.length < 4) {
      setConfirmPinError('Please confirm your 4-digit PIN')
    } else if (pin.confirmPin.length < 4) {
      setConfirmPinError('Please confirm your 4-digit PIN')
    } else if (pin.newPin !== pin.confirmPin) {
      setConfirmPinError('Please enter same PIN value in both the fields')
      setNewPinError('Please enter same PIN value in both the fields')
    } else if (pin.oldPin === pin.newPin) {
      setOldPinError('Old Password and New Password is same')
    } else {
      dispatch(handleChangePin(pin.newPin, pin.oldPin, accessToken, navigate));
    }
  }
 
const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e)
    }
};
  const handlePin = e => {
    setConfirmPinError('')
    setNewPinError('')
    setOldPinError('')
    dispatch(setValidationError(''))
    const numRegex = /^[^a-zA-Z!@#$%^&*()_+=[\]{}|;':",./<>?]*$/
    const targetName = e.target.name
    const value = e.target.value
    if (numRegex.test(value)) {
      setPin({ ...pin, [targetName]: value })
    }
  }
  useEffect(() => {
    if (changePinStatus) {
      setPinChangedMsg(
        'Your PIN has been changed.. You will be redirected to Signin Page.. '
      )
      setTimeout(() => {
        removeFromLocalStorage("gk");
        window.location.href="/signin";
      }, 3000)
    }
    if (validationError === 'PASSWORD_VALIDATION_FAILED') {
      setOldPinError('Please enter correct existing 4 digit PIN')
    }
  }, [changePinStatus, validationError])
  return (
    <div className='SB-page-content'>
      <div className='SB-myAccountSection-container SB-changePIN'>
        <div className='SB-pageHeader'>
          <div className='SB-pageHeader-title'>Change PIN</div>
        </div>      

        <div className='SB-content'>
        {changePinStatus ? (
          <>
            <br></br>
            <div className="SB-msgBox">
               <div className="SB-msgBox-container">{pinChangedMsg}</div>
            </div>
            <br></br>
          </>
        ) : (
          <></>
        )}
          <div className='SB-form-group'>
            <div className='SB-form-label'>Enter existing 4 digit PIN:</div>
            <div className='SB-form-control-group SB-form-control-password'>
              <div className='SB-form-control'>
                <input
                  type={pinType.oldPinType}
                  id='oldPass'
                  placeholder='Enter Your PIN'
                  maxLength='4'
                  required=''
                  name='oldPin'
                  value={pin.oldPin}
                  onChange={e => handlePin(e)}
                />
              </div>
              <div
                className='SB-form-addon SB-addon-right'
                onClick={() => handlePinVisibility('oldPinType')}
              >
                {pinType.oldPinType === 'password' ? (
                  <div
                    className='SB-iconSVG'
                    title='password active'
                    id='getShowPwdId'
                  >
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref={`${icons}#${'icon-password-active'}`} />
                    </svg>
                  </div>
                ) : (
                  <div
                    className='SB-iconSVG '
                    title='Password hide'
                    id='getHidePwdId'
                  >
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref={`${icons}#${'icon-password'}`} />
                    </svg>
                  </div>
                )}
              </div>
            </div>
            <div className='SB-form-errorMsg'>
              <span>{oldPinError}</span>
            </div>
          </div>
          <div className='SB-form-group'>
            <div className='SB-form-label'>Enter new 4 digit PIN:</div>
            <div className='SB-form-control-group SB-form-control-password'>
              <div className='SB-form-control'>
                <input
                  type={pinType.newPinType}
                  id='newPass'
                  placeholder='Enter Your PIN'
                  maxLength='4'
                  required=''
                  name='newPin'
                  value={pin.newPin}
                  onChange={e => handlePin(e)}
                />
              </div>
              <div
                className='SB-form-addon SB-addon-right'
                onClick={() => handlePinVisibility('newPinType')}
              >
                {pinType.newPinType === 'password' ? (
                  <div
                    className='SB-iconSVG'
                    title='password active'
                    id='getShowPwdId'
                  >
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref={`${icons}#${'icon-password-active'}`} />
                    </svg>
                  </div>
                ) : (
                  <div
                    className='SB-iconSVG '
                    title='Password hide'
                    id='getHidePwdId'
                  >
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref={`${icons}#${'icon-password'}`} />
                    </svg>
                  </div>
                )}
              </div>
            </div>
            <div className='SB-form-errorMsg'>
              <span>{newPinError}</span>
            </div>
          </div>
          <div className='SB-form-group'>
            <div className='SB-form-label'>Confirm new 4 digit PIN:</div>
            <div className='SB-form-control-group SB-form-control-password'>
              <div className='SB-form-control'>
                <input
                  type={pinType.confirmPinType}
                  id='confirmPass'
                  placeholder='Enter Your PIN'
                  maxLength='4'
                  required=''
                  name='confirmPin'
                  value={pin.confirmPin}
                  onChange={e => handlePin(e)}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <div
                className='SB-form-addon SB-addon-right'
                onClick={() => handlePinVisibility('confirmPinType')}
              >
                {pinType.confirmPinType === 'password' ? (
                  <div
                    className='SB-iconSVG'
                    title='password active'
                    id='getShowPwdId'
                  >
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref={`${icons}#${'icon-password-active'}`} />
                    </svg>
                  </div>
                ) : (
                  <div
                    className='SB-iconSVG '
                    title='Password hide'
                    id='getHidePwdId'
                  >
                    <svg xmlns='http://www.w3.org/2000/svg'>
                      <use xlinkHref={`${icons}#${'icon-password'}`} />
                    </svg>
                  </div>
                )}
              </div>
            </div>
            <div className='SB-form-errorMsg'>
              <span>{confirmPinError}</span>
            </div>
          </div>
          <div className='SB-space10'></div>
          <button
            className='btn SB-btnSecondary active SB-btnLarge'
            onClick={e => handleSubmit(e)}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="SB-loader-container">
                <div className="SB-loader"></div>
              </div>
            ) : (
              'Change PIN'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChangePin